import { styled, Typography, media, Flex, selectTheme } from '@creditas-ui/react';
import { CardContent as OriginalCardContent } from '@/components/Card';

const Title = styled(Typography)`
  margin-bottom: 8px;

  ${media.up('5xl')} {
    margin-bottom: 4px;
  }
`;

const Description = styled(Typography)``;

const CardContent = styled(OriginalCardContent)`
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  background-color: ${selectTheme('colors.neutral.0')};
  padding: 24px 16px;
  margin-bottom: 48px;

  ${media.up('5xl')} {
    display: flex;
    justify-content: space-between;
    margin: 0;
  }
`;

const Icon = styled(Flex)`
  width: 40px;
  height: 40px;
  margin-right: 16px;
  align-items: center;
  justify-content: center;

  ${media.up('5xl')} {
    width: 48px;
    height: 48px;
  }
`;

export { Title, Description, CardContent, Icon };
